import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

export const initialize = (user) => {
  if (datadogRum.getUser()?.key) {
    // already initialized
    return;
  }
  datadogRum.init({
    applicationId: import.meta.env.UF_DATADOG_APP_ID,
    clientToken: import.meta.env.UF_DATADOG_CLIENT_TOKEN,
    service: `uf-dashboard-${import.meta.env.UF_DD_ENV}`,
    env: import.meta.env.UF_DD_ENV,
    version: import.meta.env.UF_DD_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackInteractions: true,
    trackUserInteractions: true,
    plugins: [reactPlugin({ router: true })],
  });
  datadogRum.setUser({
    id: user.key,
    email: user.email,
    name: user.username,
  });
};
